import React from 'react';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';

export const ProgressOverlay = (props: CircularProgressProps) => {
  const { className } = props;
  return (
    <div className={`progress-wrapper ${className}`}>
      <CircularProgress color='primary' size={50} />
    </div>
  );
};
